export const wrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
};

export const warningBoxStyles = {
  padding: '8px 12px',
  borderRadius: '4px',
  backgroundColor: 'rgba(255, 152, 0, 0.1)',
  border: '1px solid rgba(255, 152, 0, 0.4)',
};
